import { t } from "@lingui/macro";
import * as React from "react";
import { Path, Circle } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const FullCartIcon = (props: IconProps) => (
  <Icon
    viewBox="0 0 16 16"
    fill="none"
    title={t`Full Cart`}
    {...props}
    testID="full-cart-icon"
  >
    <Path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M11.595 7.676 15 8.432v.892m-3.405-1.648H5.54v-.757h-.757m6.81.757L10.46 2M4.784 6.919h-2.27m2.27 0V3.892m0-1.892h5.676M4.784 2h-.757m.757 0v1.892M10.46 2h1.135M2.514 6.919H1.378L1 12.216h7M2.514 6.92V3.892h2.27"
      fill="none"
    />
    <Circle
      cx={4.027}
      cy={12.216}
      r={1.514}
      fill="#fff"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
    />
    <Path
      fill="currentColor"
      d="M9.269 16h4.552v-1.25H11.33v-.04l.736-.708c1.333-1.211 1.681-1.828 1.681-2.564 0-1.155-.904-1.938-2.3-1.938-1.36 0-2.27.817-2.267 2.123h1.408c0-.58.342-.914.853-.914.502 0 .865.322.865.851 0 .48-.288.805-.793 1.278l-2.243 2.047V16Z"
    />
  </Icon>
);
